import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'jquery';

import { HeaderService } from '../header.service';
import RoutesserviceService from '../routesservice.service';
import { DashboardService } from '../dashboardservices/dashboard.service';
import { ThemeService } from 'src/app/theme.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  public submitAttempt = false;
  refresh: any;

  constructor(private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService,
    public dashboardService: DashboardService,
    private themeService: ThemeService,

  ) {


  }


  /*
    Checking Login for our guard
  */

  isLoggedIn() {
    if (localStorage.getItem('token')) {
      return true;
    } else {
      return false;
    }
  }




  /*
    When it submit the form then this will hit this url
  */
  async login(email: string, password: string) {
    // let check = false;
    return this.httpClient
      .post(this.Customeroutes.getLogin(), {
        header: this.HeaderService.getHeaderWithoutToken(),
        email: email,
        password: password,
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          localStorage.clear();
          localStorage.setItem('token', data.data.token);
          localStorage.setItem('user', JSON.stringify(data.data.user));
          localStorage.setItem('theme_id', data.data.user.theme_id);
          this.themeService.setThemeId();
          const token = localStorage.getItem('token')
          return data;
        }
        return data;
      });
  }



  async newlogin(formdata: any) {
    const data = { email: formdata.email, password: formdata.password }
    return this.httpClient
      .post(this.Customeroutes.getLogin(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {

          return data;

        }
        return data;
      }).catch((error) => {
        // ✅ Rethrow error so the caller can catch it properly
        throw error;
      });;
  }

  async updatePassword(email: string, newPassword: string, OldPassword: string) {
    // let check = false;

    return this.httpClient
      .post(this.Customeroutes.recoverPassword(), {
        header: this.HeaderService.getHeaderWithoutToken(),
        email: email,
        password: newPassword,
        old_password: OldPassword,
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
    //alert(check);
    // return check;
  }

  async updatePinCode(email: string, newPin: string, OldPin: string) {
    // let check = false;
    return this.httpClient
      .post(this.Customeroutes.recoverPinCode(), {
        header: this.HeaderService.getHeaderWithoutToken(),
        email: email,
        new_pin: newPin,
        old_pin: OldPin,
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
    //alert(check);
    // return check;
  }

  async checkPincode(email: string, pincode: string) {

    const data = { email: email, pincode: pincode, }
    return this.httpClient
      .post(this.Customeroutes.checkPin(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {

          return data;

        }
        return data;
      });

  }

    // 2FA methods
    async setup2fa(token : string) {
      return this.httpClient
        .post(this.Customeroutes.get2FASetup(), {}, {
          headers: this.HeaderService.getHeaderWithToken(
            token
          ),
        })
        .toPromise()
        .then((data: any) => data);
    }

    async verify2fa(token : string,code: string) {
      const body = { code };
      return this.httpClient
        .post(this.Customeroutes.get2FAVerify(), body, {
          headers: this.HeaderService.getHeaderWithToken(
            token
          ),
        })
        .toPromise()
        .then((data: any) => data);
    }

    async enable2fa(token : string) {
      return this.httpClient
        .post(this.Customeroutes.get2FAEnable(), {}, {
          headers: this.HeaderService.getHeaderWithToken(
            token
          ),
        })
        .toPromise()
        .then((data: any) => data);
    }

    async validate2fa(token : string,code: string) {
      const body = { code };
      return this.httpClient
        .post(this.Customeroutes.get2FAValidate(), body, {
          headers: this.HeaderService.getHeaderWithToken(
            token
          ),
        })
        .toPromise()
        .then((data: any) => data);
    }

    async setup2faWithTempToken(tempToken: string) {
      return this.httpClient
        .post(this.Customeroutes.get2FASetupLogin(), {}, {
          headers: this.HeaderService.getHeaderWithToken(tempToken),
        })
        .toPromise()
        .then((data: any) => data);
    }

    async verifyLoginOtp(tempToken: string, otpCode: string) {
      return this.httpClient
        .post(this.Customeroutes.getAuthVerifyOtp(), { otp_code: otpCode }, {
          headers: this.HeaderService.getHeaderWithToken(tempToken),
        })
        .toPromise()
        .then((data: any) => data);
    }



    

 async getkeysdetail(token : string) {
      return this.httpClient
        .post(this.Customeroutes.getkeysData(), {}, {
          headers: this.HeaderService.getHeaderWithToken(
            token
          ),
        })
        .toPromise()
        .then((data: any) => data);
    }

async sendOtp(email:any) {
  const body = { email: email };
    return this.httpClient
      .post(this.Customeroutes.otpSend(), body, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {

          return data;

        }
        return data;
      });

  }




  
   async verifyOtp(otp: any) {

    const data = { otp: otp }
    return this.httpClient
      .post(this.Customeroutes.verifyOtp(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {

          return data;

        }
        return data;
      });

  }




  
  async setNewPin(otp: any) {

    const data = { pincode: otp }
    return this.httpClient
      .post(this.Customeroutes.newPin(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {

          return data;

        }
        return data;
      });

  }

}



